import styled from "styled-components";
import { Color, Font, breakpoints, ColorDark } from "@/shared/Constants";

export const TextContainer = styled.div`

h2 {
  ${Font.clarinVarSub2Regular};
  font-size: 21px;
  line-height: 26px;
  color: ${Color.grey};
  padding-top: 8px;
  margin-bottom: 50px;
  ${breakpoints.darkMode} {
    [data-theme='dark'] & {
    color:${ColorDark.textLight};
    }
  }
  ${breakpoints.phone} {
    font-size: 17px;
    line-height: 23px;
  }
    }
`


export const AstrologyCardContainer = styled.div`
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  width: 100%;
  ${breakpoints.tablet} {
    border-right: none;
  }
  ${breakpoints.phone} {
    border-right: none;
  }
  .astrology-card {
    align-items: center;
    border-bottom: 1px solid ${Color.greySeparator};
    display: flex;
    flex-direction: column;
    justify-content: center;
    position: relative;
    width: calc(100% / 3);
    min-height: 412px;
    ${breakpoints.darkMode} {
      [data-theme='dark'] & {
      border-bottom:1px solid ${ColorDark.greySeparator};
      }
    }
    ${breakpoints.tablet} {
      width: 100%;
      min-height: auto;
    }
    ${breakpoints.phone} {
      width: 100%;
      min-height: auto;
    }
    &:nth-child(3n) {
      &::after {
        width: 0;
      }
    }
    &:nth-last-child(-n + 3) {
      border-bottom: none;
      ${breakpoints.phone} {
        border-bottom: 1px solid ${Color.greySeparator};
        ${breakpoints.darkMode} {
          [data-theme='dark'] & {
          border-bottom:1px solid ${ColorDark.greySeparator};
          }
        }
      }
    }
    &:last-child {
      ${breakpoints.phone} {
        border-bottom: none;
      }
    }
    &::after {
      background-color: ${Color.greySeparator};
      content: "";
      height: 92%;
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
      width: 1px;
      ${breakpoints.tablet} {
        width: 0;
      }
      ${breakpoints.phone} {
        width: 0;
      }
    }
    &:nth-child(-n + 3) {
      &::after {
        height: 96%;
        top: 0;
        transform: none;
      }
      .astrology-main-link {
        .astrology-image {
          margin-top: 15px;
        }
      }
    }
    .astrology-main-link {
      align-items: center;
      display: flex;
      flex-direction: column;
      justify-content: center;
      text-decoration: none;
      position: relative;
      width: 100%;
      ${breakpoints.tablet} {
        flex-direction: row;
        gap: 50px;
        padding-bottom: 30px;
      }
      ${breakpoints.phone} {
        flex-direction: row;
        gap: 50px;
        padding-bottom: 30px;
      }
      .astrology-image {
        margin: 0;
        height: 106px;
        margin-top: 30px;
        width: 106px;
        ${breakpoints.phone} {
          margin-bottom: 20px;
        }
        img {
          max-width: 100%;
          width: 100%;
        }
      }
      .astrology-content {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        ${breakpoints.tablet} {
          width: calc(70% - 126px);
        }
        ${breakpoints.phone} {
          width: calc(70% - 126px);
        }
        .astrology-sign-name {
          ${Font.sansBold};
          color: ${Color.black000};
          font-size: 24px;
          padding-bottom: 5px;
          padding-top: 20px;
          text-align: center;
          ${breakpoints.darkMode} {
            [data-theme='dark'] & {
            color:${ColorDark.textLight};
            }
          }
        }
        .astrology-sign-date {
          align-items: center;
          display: flex;
          justify-content: center;
          .astrology-sign-years {
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            justify-content: center;
            text-align: center;
            padding: 0px 50px;
            ${Font.sansRegular};
            color: ${Color.black000};
            font-size: 16px;
            line-height: 22px;
            ${breakpoints.darkMode} {
              [data-theme='dark'] & {
              color:${ColorDark.textLight};
              }
            }
            ${breakpoints.tablet} {
              padding: 0px;
            }
            ${breakpoints.phone} {
              padding: 0px;
            }
          }
          .astrology-sign-since,
          .astrology-sign-dash,
          .astrology-sign-until {
            ${Font.sansRegular};
            color: ${Color.black000};
            font-size: 16px;
            ${breakpoints.darkMode} {
              [data-theme='dark'] & {
              color:${ColorDark.textLight};
              }
            }
          }
          .astrology-sign-dash {
            padding: 0 5px;
          }
        }
        .astrology-day{
          display: flex;
          flex-wrap: wrap;
          align-items:center;
          justify-content: center;
          margin-bottom: 63px;
          margin-top: 30px;
          ${breakpoints.phone} {
            display: block;
            margin-bottom: 0;
          }
        }
      }
    }
  }
`;
